import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsClubSellingMemberships_club$key } from "./__generated__/useIsClubSellingMemberships_club.graphql";

export const useIsClubSellingMemberships = (
  clubRef?: useIsClubSellingMemberships_club$key | null
) => {
  const club = useFragment(useIsClubSellingMembershipsFragmentString, clubRef);

  return (club?.memberships?.count ?? 0) > 0;
};

const useIsClubSellingMembershipsFragmentString = graphql`
  fragment useIsClubSellingMemberships_club on Club {
    memberships: packages(packageType: MEMBERSHIP, saleAvailability: PUBLIC) {
      count
    }
  }
`;
